<template>
  <div>
    <div v-if="!questionAnswered" class="px-8">
      <div class="mt-6 py-5 text-left">
        <!-- <p class="text-sm mb-2">Frage {{ question.prio }} von 6</p> -->
        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      <form @submit.prevent="submit" novalidate class="mt-3 text-center">
        <div class="ml-auto mr-auto max-w-4xl rounded-md shadow-sm">
          <textarea v-model="form.answer" :disabled="sending" rows="3"
            class="shadow-sm focus:ring-markencode-blue focus:border-markencode-blue mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"></textarea>
        </div>

        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-4">{{
          translations.save }}</submit-button>
      </form>
    </div>


    <div v-if="questionAnswered && session.show_live_results" class="mt-6 px-8 py-5 text-left">
      <p class="text-sm mb-2">Und das sagt die Gruppe:</p>

      <p class="font-extralight text-lg">{{ generatedQuestion }}</p>

      <div class="border-t border-gray-400 mt-4"></div>

      <scrollable-container :session="session" :translations="translations"></scrollable-container>
    </div>

    <div v-if="questionAnswered && !session.show_live_results" class="mt-6 px-8 py-5 text-left">
      <h1 class="text-3xl sm:text-4xl font-extralight mb-3">
        {{ translations.thank_you }}
      </h1>
    </div>

  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import ScrollableContainer from '@/Pages/LiveResults/ScrollableContainer';
import { throttle } from 'lodash';

export default {
  components: {
    SubmitButton,
    ScrollableContainer,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        answer: '',
      },
    };
  },

  methods: {
    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('live.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    validated() {
      return this.form.answer.length;
    },
    questionAnswered() {
      return this.answerParameters || this.answered;
    },
    channel() {
      return Echo.channel(
        'markencode-app.session.' + this.participant.markencode_session.id
      );
    },
  },

  created() {
    // this.channel.here((users) => {
    //     console.log(users);
    // })
  },

  destroyed() {
    console.log('leaving textblock single component');
    // this.channel.leave('markencode-live.session.' + this.participant.markencode_session.id);
  },

  // watch: {
  //   form: {
  //     handler: throttle(function() {
  //       this.channel.whisper(
  //         'participant.busy',
  //         {
  //           participant_id: this.participant.id
  //         }
  //       );
  //     }, 2000),
  //     deep: true
  //   }
  // }
};
</script>